import React from 'react';

const Clock = (props) => (
  <svg
    viewBox="0 0 14.274 14.348"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>{`.clockicon{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.5px;}`}</style>
    </defs>
    <g transform="translate(0.375)">
      <path
        className="clockicon"
        d="M76.267,169.057a6.742,6.742,0,0,1,4.782-1.981h0a6.761,6.761,0,0,1,6.762,6.762h0a6.761,6.761,0,0,1-6.762,6.762h0a6.761,6.761,0,0,1-6.762-6.762h0"
        transform="translate(-74.287 -166.627)"
      />
      <path
        className="clockicon"
        d="M75.871,166.627v2.855h2.855"
        transform="translate(-74.287 -166.627)"
      />
      <path
        className="clockicon"
        d="M84.423,173.838H81.049v-4.847"
        transform="translate(-74.287 -166.627)"
      />
    </g>
  </svg>
);

export default Clock;
